import { Stack, Text, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/referrals/exam-access-arrangements')({ component: Page })
function Page() { return <Stack p="lg"><Title order={2}>Exam Access Arrangements</Title><Text c="dimmed">Exam Access Arrangement referral options will appear here.</Text></Stack> }
